import Vue from 'vue';
import users from '../../users';
import axios from 'axios';

export default {
  name: 'ConfirmLink',
  mixins: [users],
  data: function () {
    return {
      message: 'Please wait a moment ...',
    }
  },
  methods: {
    redirectLogin() {
      this.$router.push('/login');
    },
    logout() {
      axios.post('/account/Logout')
        .then(response => {
          this.user.authenticated = false;
          this.$localStorage.set('_login', null);
          this.$localStorage.set('_preference', null);
          this.$localStorage.set('_property', null);
          this.resetUserDetails();
          this.$router.push('/login');
        })
        .catch(e => { this.$router.push('/login'); })
    },
    confirmLink(code) {
      if (!code || code == '') {
        this.message = 'Wrong code provided';
        setTimeout(function () { this.logout(); }.bind(this), 5000);
        //setTimeout(this.logout(), 5000);
      }
      else {
        axios.post('/account/ChangeEmailComplete', { Value: code })
          .then(response => {
            if (response.status == 200 && (!response.data || response.data.data.status == 0)) {
              this.message = 'Email address confirmed, you will be redirected to login page in a moment.';
              setTimeout(function () { this.logout(); }.bind(this), 3000);
              //setTimeout(this.logout(), 3000);
            }
            else
              this.message = response.data.data.text;
          })
          .catch(e => {
            console.log(e);
            this.message = e.Message;
          })
      }
    },
  },
  created() {
    var code = this.$route.params.code;
    this.confirmLink(code);
  }
}
